import { requests, mainApiRoot } from './index'

export const BacklinkChecker = {
  get: payload => requests.post(mainApiRoot, '/backlink-checker', payload),
  getPrevious: historyId => requests.get(mainApiRoot, `/backlink-checker/history/${historyId}`),
  getHistory: () => requests.get(mainApiRoot, '/backlink-checker/history'),
  del: historyId => requests.del(mainApiRoot, `/backlink-checker/history/${historyId}`)
}